import { ALLOWED_LABEL_LAYOUTS, sanitizeAllowedString, sanitizeBindable, sanitizeBoolean, sanitizeBoundValue, sanitizeString } from './helpers';
const ALLOWED_TIMEZONE_PICKER_WIDTHS = ['full', 'auto'];
export function sanitizeTimezonePicker(el) {
  const value = sanitizeBoundValue(el.value);
  if (!value) return null;
  return {
    type: 'TimezonePicker',
    value,
    label: sanitizeBindable(el.label, sanitizeString),
    labelLayout: sanitizeBindable(el.labelLayout, v => sanitizeAllowedString(v, ALLOWED_LABEL_LAYOUTS)),
    width: sanitizeBindable(el.width, v => sanitizeAllowedString(v, ALLOWED_TIMEZONE_PICKER_WIDTHS)),
    required: sanitizeBindable(el.required, sanitizeBoolean),
    disabled: sanitizeBindable(el.disabled, sanitizeBoolean)
  };
}